import gql from 'graphql-tag';

export const ADD_PATCH_FRAGMENT = gql`
    fragment AddPatchFragment on AddPatch {
        op
        path
        value
    }
`;

export const REPLACE_PATCH_FRAGMENT = gql`
    fragment ReplacePatchFragment on ReplacePatch {
        op
        path
        value
        oldValue
    }
`;

export const REMOVE_PATCH_FRAGMENT = gql`
    fragment RemovePatchFragment on RemovePatch {
        op
        path
        oldValue
    }
`;

export const MOVE_PATCH_FRAGMENT = gql`
    fragment MovePatchFragment on MovePatch {
        op
        path
        from
    }
`;

export const COPY_PATCH_FRAGMENT = gql`
    fragment CopyPatchFragment on CopyPatch {
        op
        path
        from
    }
`;

export const TEST_PATCH_FRAGMENT = gql`
    fragment TestPatchFragment on TestPatch {
        op
        path
        value
    }
`;

export const AUDIT_LOG_PATCH_FRAGMENT = gql`
    fragment AuditLogPatchFragment on AuditLogPatch {
        ... on AddPatch {
            ...AddPatchFragment
        }
        ... on ReplacePatch {
            ...ReplacePatchFragment
        }
        ... on RemovePatch {
            ...RemovePatchFragment
        }
        ... on MovePatch {
            ...MovePatchFragment
        }
        ... on CopyPatch {
            ...CopyPatchFragment
        }
        ... on TestPatch {
            ...TestPatchFragment
        }
    }
    ${ADD_PATCH_FRAGMENT}
    ${REPLACE_PATCH_FRAGMENT}
    ${REMOVE_PATCH_FRAGMENT}
    ${MOVE_PATCH_FRAGMENT}
    ${COPY_PATCH_FRAGMENT}
    ${TEST_PATCH_FRAGMENT}
`;

/** UNE ligne d'audit, sans ses voisines : c'est la moitié non récursive, celle qu'on peut imbriquer. */
export const AUDIT_LOG_ENTRY_FRAGMENT = gql`
    fragment AuditLogEntryFragment on AuditLog {
        _id
        createdAt
        updatedAt
        createdBy
        createdByName
        collectionName
        collectionDocumentId
        operation
        requestId
        requestName
        patches {
            ...AuditLogPatchFragment
        }
    }
    ${AUDIT_LOG_PATCH_FRAGMENT}
`;

/**
 * Une ligne ET les autres écritures de la même action — document principal, documents secondaires.
 *
 * Le serveur les porte sur la ligne elle-même : afficher vingt lignes reste UNE requête, et le front
 * n'a plus à recoudre les `requestId` après coup.
 */
export const AUDIT_LOG_FRAGMENT = gql`
    fragment AuditLogFragment on AuditLog {
        ...AuditLogEntryFragment
        sameRequestAuditLogs {
            ...AuditLogEntryFragment
        }
    }
    ${AUDIT_LOG_ENTRY_FRAGMENT}
`;
